import type { SentryEventFilter } from '../types'

export const filterNetworkFailedToFetch: SentryEventFilter = ({
  apolloError,
}) => {
  return Boolean(apolloError?.message?.includes('Failed to fetch'))
}
